import {Component, OnInit} from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';
import { version } from '../../../../../environments/version';
import { environment } from '../../../../../environments/environment';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'qm-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent {

  public loggedIn$: Observable<boolean>;
  public version: { version: string, date: string };

  /**
   * Inits the view.
   * @param auth
   */
  constructor(public auth: AuthService) {
    this.loggedIn$ = this.auth.login$.pipe(map(() => true));
    this.version = {
      version,
      // TODO: do something else?
      date: undefined
    };
  }

  /**
   * Is production version in use.
   */
  public isProduction(): boolean {
    return environment.production;
  }
}
